import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { OrganizationRoles, apiCreateCommunityUser, apiCreateUser, apiGetUser, apiUpdateUser, isPublishOnline, judgeIsJoveMasterAdmin, judgeIsJoveSalesAdmin, judgeIsOnlyBossMasterAdmin } from '@jove-frontend/uikit';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
var CmsUrl = process.env['NX_CMS_URL'];
export var useAuthStore = create()(immer(function (set, get) {
  return {
    state: {
      user: null,
      userRoles: null,
      clientPortalUrl: null,
      isUserOnboarded: null,
      isCommunityUser: null,
      isJoveAdmin: null,
      isLoading: null,
      isParentBroker: false,
      isSubBroker: true,
      isJoveSaleAdmin: false,
      isJoveMasterAdmin: false
    },
    actions: {
      setUser: function setUser(user) {
        var _user$organizations, _user$organizations$f;

        var isUserOnboarded = !!(user.first_name && user.last_name && user.user_information && typeof user.user_information.has_business_insurance === 'boolean');
        var organizationSlug = (_user$organizations = user.organizations) === null || _user$organizations === void 0 ? void 0 : (_user$organizations$f = _user$organizations.find(function (org) {
          return org.slug !== 'joveco';
        })) === null || _user$organizations$f === void 0 ? void 0 : _user$organizations$f.slug;
        set(function (store) {
          var _store$state$userRole;

          store.state.user = user;
          store.state.isUserOnboarded = isUserOnboarded;

          if (organizationSlug && (_store$state$userRole = store.state.userRoles) !== null && _store$state$userRole !== void 0 && _store$state$userRole.includes(OrganizationRoles.ORG_ADMIN)) {
            store.state.clientPortalUrl = "".concat(CmsUrl, "/organization/").concat(organizationSlug);
          }

          store.state.isJoveMasterAdmin = judgeIsJoveMasterAdmin(user);
          store.state.isOnlyBossMasterAdmin = isPublishOnline() ? judgeIsOnlyBossMasterAdmin(user) : judgeIsJoveMasterAdmin(user);
        });
      },
      setUserRoles: function setUserRoles(roles) {
        var isCommunityUser = !!(roles !== null && roles !== void 0 && roles.includes('community-user'));
        var isJoveAdmin = !!(roles !== null && roles !== void 0 && roles.includes(OrganizationRoles.JOVE_ADMIN));
        set(function (store) {
          store.state.userRoles = roles;
          store.state.isCommunityUser = isCommunityUser;
          store.state.isJoveAdmin = isJoveAdmin;
          store.state.isJoveSaleAdmin = judgeIsJoveSalesAdmin({
            userRoles: roles
          });
        });
      },
      fetchUser: function () {
        var _fetchUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
          var _yield$apiGetUser, _yield$apiGetUser2, user, err;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  set(function (store) {
                    store.state.isLoading = true;
                  });
                  _context.next = 3;
                  return apiGetUser(id);

                case 3:
                  _yield$apiGetUser = _context.sent;
                  _yield$apiGetUser2 = _slicedToArray(_yield$apiGetUser, 2);
                  user = _yield$apiGetUser2[0];
                  err = _yield$apiGetUser2[1];

                  if (user) {
                    get().actions.setUser(user);
                  }

                  set(function (store) {
                    store.state.isLoading = false;
                  });
                  return _context.abrupt("return", user);

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function fetchUser(_x) {
          return _fetchUser.apply(this, arguments);
        }

        return fetchUser;
      }(),
      fetchUserWithNewResponse: function () {
        var _fetchUserWithNewResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
          var _yield$apiGetUser3, _yield$apiGetUser4, user, err;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  set(function (store) {
                    store.state.isLoading = true;
                  });
                  _context2.next = 3;
                  return apiGetUser(id);

                case 3:
                  _yield$apiGetUser3 = _context2.sent;
                  _yield$apiGetUser4 = _slicedToArray(_yield$apiGetUser3, 2);
                  user = _yield$apiGetUser4[0];
                  err = _yield$apiGetUser4[1];

                  if (user) {
                    get().actions.setUser(user);
                  }

                  set(function (store) {
                    store.state.isLoading = false;
                  });
                  return _context2.abrupt("return", [user, err]);

                case 10:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function fetchUserWithNewResponse(_x2) {
          return _fetchUserWithNewResponse.apply(this, arguments);
        }

        return fetchUserWithNewResponse;
      }(),
      registerUser: function () {
        var _registerUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
          var _yield$apiCreateUser, _yield$apiCreateUser2, user, err;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  set(function (store) {
                    store.state.isLoading = true;
                  });
                  _context3.next = 3;
                  return apiCreateUser(payload);

                case 3:
                  _yield$apiCreateUser = _context3.sent;
                  _yield$apiCreateUser2 = _slicedToArray(_yield$apiCreateUser, 2);
                  user = _yield$apiCreateUser2[0];
                  err = _yield$apiCreateUser2[1];

                  if (user) {
                    get().actions.setUser(user);
                  }

                  set(function (store) {
                    store.state.isLoading = false;
                  });

                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function registerUser(_x3) {
          return _registerUser.apply(this, arguments);
        }

        return registerUser;
      }(),
      registerToCommunity: function () {
        var _registerToCommunity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(auth0Id, payload) {
          var _yield$apiCreateCommu, _yield$apiCreateCommu2, user, err;

          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  set(function (store) {
                    store.state.isLoading = true;
                  });
                  _context4.next = 3;
                  return apiCreateCommunityUser(auth0Id, payload);

                case 3:
                  _yield$apiCreateCommu = _context4.sent;
                  _yield$apiCreateCommu2 = _slicedToArray(_yield$apiCreateCommu, 2);
                  user = _yield$apiCreateCommu2[0];
                  err = _yield$apiCreateCommu2[1];

                  if (user) {
                    get().actions.setUser(user);
                  }

                  set(function (store) {
                    store.state.isLoading = false;
                  });

                case 9:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function registerToCommunity(_x4, _x5) {
          return _registerToCommunity.apply(this, arguments);
        }

        return registerToCommunity;
      }(),
      updateUser: function () {
        var _updateUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
          var user, _yield$apiUpdateUser, _yield$apiUpdateUser2, userRes, err;

          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  set(function (store) {
                    store.state.isLoading = true;
                  });
                  user = get().state.user;
                  _context5.next = 4;
                  return apiUpdateUser(user.id, payload);

                case 4:
                  _yield$apiUpdateUser = _context5.sent;
                  _yield$apiUpdateUser2 = _slicedToArray(_yield$apiUpdateUser, 2);
                  userRes = _yield$apiUpdateUser2[0];
                  err = _yield$apiUpdateUser2[1];

                  if (userRes) {
                    get().actions.setUser(userRes);
                  }

                  set(function (store) {
                    store.state.isLoading = false;
                  });
                  return _context5.abrupt("return", err ? false : true);

                case 11:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        function updateUser(_x6) {
          return _updateUser.apply(this, arguments);
        }

        return updateUser;
      }(),
      updateIsParentBroker: function updateIsParentBroker(isParentBroker) {
        set(function (store) {
          store.state.isParentBroker = isParentBroker;
        });
      },
      updateIsSubBroker: function updateIsSubBroker(isSubBroker) {
        set(function (store) {
          store.state.isSubBroker = isSubBroker;
        });
      },
      getUserAllInfo: function getUserAllInfo() {
        var _get$state = get().state,
            isJoveAdmin = _get$state.isJoveAdmin,
            isParentBroker = _get$state.isParentBroker,
            isSubBroker = _get$state.isSubBroker,
            isJoveSaleAdmin = _get$state.isJoveSaleAdmin,
            isJoveMasterAdmin = _get$state.isJoveMasterAdmin,
            isOnlyBossMasterAdmin = _get$state.isOnlyBossMasterAdmin;
        return {
          isJoveAdmin: isJoveAdmin,
          isParentBroker: isParentBroker,
          isSubBroker: isSubBroker,
          isJoveSaleAdmin: isJoveSaleAdmin,
          isJoveMasterAdmin: isJoveMasterAdmin,
          isOnlyBossMasterAdmin: isOnlyBossMasterAdmin
        };
      }
    }
  };
}));